import React, { createContext, useContext, useState, useEffect } from 'react'

interface DemoModeContextType {
  isDemoMode: boolean
  toggleDemoMode: () => void
}

const DemoModeContext = createContext<DemoModeContextType | undefined>(
  undefined
)

export function DemoModeProvider({ children }: { children: React.ReactNode }) {
  const [isDemoMode, setIsDemoMode] = useState(() => {
    const saved = localStorage.getItem('demoMode')
    // По умолчанию режим демо выключен (false), всё disabled
    if (saved === null) {
      return false
    }
    return saved === 'true'
  })

  useEffect(() => {
    localStorage.setItem('demoMode', String(isDemoMode))
  }, [isDemoMode])

  const toggleDemoMode = () => {
    setIsDemoMode((prev) => !prev)
  }

  return (
    <DemoModeContext.Provider value={{ isDemoMode, toggleDemoMode }}>
      {children}
    </DemoModeContext.Provider>
  )
}

export function useDemoMode() {
  const context = useContext(DemoModeContext)
  if (context === undefined) {
    throw new Error('useDemoMode must be used within a DemoModeProvider')
  }
  return context
}
